<template>
  <div
    class="app-button-list"
    :class="[styles, computedStyles]"
  >
    <AppButtonListItem
      v-for="(button, index) in buttons"
      :key="index"
      :text="button.text"
      :active="button.value === value"
      :theme="theme"
      @click="$emit('input', button.value)"
    />
  </div>
</template>

<script>
/**
 * AppButtonList
 * @desc A column of ButtonListItems
 */
import AppButtonListItem from '@/components/common/buttons/AppButtonListItem'
import theme from '@/mixins/theme'

export default {
  // Name
  name: 'AppButtonList',

  // Components
  components: {
    AppButtonListItem
  },

  mixin: [theme],

  // Props
  props: {
    row: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Array,
      default: () => [],
      required: true
    },
    value: {
      type: [Number, String, Boolean],
      default: ''
    },
    theme: {
      type: String,
      default: ''
    }
  },

  // Data
  data () {
    return {
      styles: [
        'm-auto',
        'w-full',
        'max-w-500',
        'lg:max-w-400'
      ]
    }
  },

  // Computed
  computed: {
    computedStyles () {
      return {
        'shadow-btnlist': !this.row,
        'flex app-button-list--row': this.row
      }
    }
  }
}
</script>

<style scoped lang="scss">
.app-button-list--row {
  .app-button-list-item {
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
